import { render } from "./BrokerPolicies.vue?vue&type=template&id=2cb818b5&scoped=true"
import script from "./BrokerPolicies.vue?vue&type=script&lang=js"
export * from "./BrokerPolicies.vue?vue&type=script&lang=js"

import "./BrokerPolicies.vue?vue&type=style&index=0&id=2cb818b5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2cb818b5"

export default script